/**
 * Implementation of Onboarding Layout component
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import React from "react";
import { FiShield } from "react-icons/fi";
import { RiSpaceShipFill } from "react-icons/ri";
import { Outlet } from "react-router-dom";
import MonitorlyLogo from "./../../images/monitorly-logo.png";

export default function Onboarding() {

  return (
    <div className="flex h-screen flex-col items-center bg-primary px-4">
      <div className="mt-36 mb-8 flex justify-center items-center">
        <img src={MonitorlyLogo} className="w-[70%]"/>
      </div>
      {/* <h1 className="text-white text-4xl font-extrabold mb-10 mt-10">
        <FiShield className="icon  mr-1" />Monitor<span className="text-accent">ly</span>
      </h1> */}

      <div className="bg-white  w-2/3">
        <Outlet />
      </div>
    </div>
  )
}